"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var Stores = require("../../store/ServiceByUUID");
var ServiceSelector = /** @class */ (function (_super) {
    __extends(ServiceSelector, _super);
    function ServiceSelector(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            pageLoad: true,
            uuid: _this.props.appId,
            version: 0
        };
        _this.onChangeService = _this.onChangeService.bind(_this);
        return _this;
    }
    ServiceSelector.prototype.onChangeService = function (e) {
        this.props.hookServiceId(this.props.appId, e.target.value);
    };
    ServiceSelector.prototype.render = function () {
        //console.log(this.props.appId);
        this.setState({
            pageLoad: true,
            uuid: this.props.appId
        });
        this.props.requestFunction(this.state.pageLoad, this.props.appId, this.state.version);
        if (this.props.isLoading && this.props.serviceLoad && this.props.version > this.state.version) {
            if ((this.props.isLoading && this.props.response.result_list != undefined)) {
                this.props.hookServiceId(this.props.appId, this.props.response.result_list[0].service_id);
            }
            this.setState({
                version: this.props.version
            });
        }
        return (React.createElement("div", { className: "form-group" },
            React.createElement("label", { htmlFor: "appSelector" },
                React.createElement("b", null, "Service Name")),
            React.createElement("select", { className: "form-control", id: "appSelector", onChange: this.onChangeService }, (this.props.isLoading && this.props.response.result_list != undefined) && this.props.response.result_list.map(function (item) {
                return React.createElement("option", { key: item.service_id, value: item.service_id }, item.service_name);
            }))));
    };
    return ServiceSelector;
}(React.PureComponent));
exports.default = react_redux_1.connect(function (state) { return state.serviceByUUIDModel; }, Stores.actionCreators)(ServiceSelector);
//# sourceMappingURL=ServiceSelector.js.map